import { useState } from "react";
import "../CSS/create-profit.css";

const CompleteStakeModal = ({ handleOk, handleCancel, initialAmount, stakeAmount }) => {
  const [form, setForm] = useState({ amount: initialAmount ?? "" });

  const onChange = (key, val) => setForm((prev) => ({ ...prev, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    handleOk({ result: form.result, amount: Number(form.amount) });
  };

  return (
    <div className="bv-create-profit-modal">
      <header>
        <h4>Complete Stake</h4>
      </header>

      <form id="completeStakeForm" className="body" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="result" className="form-label">
            Is it a profit or loss?
          </label>

          <select 
            className="form-control"
            name="result" 
            id="result"
            required
            value={form.result || ""}
            onChange={(e) => onChange(e.target.name, e.target.value)}
          >
            <option value="" disabled>Select</option>
            <option value="Profit">Profit</option>
            <option value="Loss">Loss</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="amount" className="form-label">
            Amount
          </label>

          <input
            className="form-control"
            type="number"
            id="amount"
            required
            step={"0.01"}
            name="amount"
            value={form.amount}
            onChange={(e) => onChange(e.target.name, e.target.value)}
            min={0}
            max={form.result === "Loss" ? stakeAmount : undefined}
          />
        </div>
      </form>

      <div className="actions">
        <button type="submit" form="completeStakeForm">
          Save
        </button>

        <button onClick={handleCancel}>Cancel</button>
      </div>
    </div>
  );
};

export default CompleteStakeModal;
